import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AppointmentService from '../utils/AppointmentService.js';
import { Switch, Route, Link } from 'react-router-dom'
import moment from 'moment'
import Select from 'react-select';
import HomeIcon from '../images/home.png'
import WorkIcon from '../images/business.png'
import Clock from '../images/Clock.svg'
import Calendar from '../images/Calendar.svg'
import MapPointer from '../images/MapPointer.svg'
import ApptVehicleDetails from "../Components/ApptVehicleDetails.js"
import BooleanSwitch from "../Components/BooleanSwitch.js"
import Slider from "react-slick";
import Modal from 'react-modal';
import Trash from 'react-icons/lib/fa/trash-o';
import CloseIcon from 'react-icons/lib/fa/close';
import NewCCForm from './NewCCForm.js';
import ErrorSnackBar from '../Components/ErrorSnackBar.js';
import URLService from '../utils/URLService.js';
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';

import 'react-select/dist/react-select.css';


// if (!window.Promise) {
//   window.Promise = Promise;
// }
const override = css`
    display: block;
    margin: 2% 43%;
    border-color: red;
`;
class ShowDetails extends Component {

  constructor(props) {
    super(props);
    var id = props.match.params.id
    this.Appt = new AppointmentService()
    this.state = {
        appt_id: id,
        appointment: null,
        modalIsOpen: false,
        promoString: '',
        allVehicleUpgrades: [],
        tipCalulation: 0,
        tipModalIsOpen: false,
        creditCardOptions: [],
        creditCardChosen: false,
        hideTipButtons: false,
        giftCardChoosen: false,
        creditCard: null,
        giftcardCode: '',
        giftcardAmount: '',
        accountBalance: 0,
        accoutBalanceTowardAppt: 0,
        useAccountBalance: false,
        showAccountBalanceReduction: false,
        appointmentError: null,
        successfulApptModal: false,
        newCCmodal: false,
        errorMessage:null,
        color: '#c42d2d',
        open: false,
        width: document.body.clientWidth,
        loadingModalOpen: false
    };
    this.useBalance = this.useBalance.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.closeNewCreditCard = this.closeNewCreditCard.bind(this)
    this.closeNewCCmodal = this.closeNewCCmodal.bind(this)
    this.showCreditCards = this.showCreditCards.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.goToDashboard = this.goToDashboard.bind(this)
    this.openLoadingModal = this.openLoadingModal.bind(this)
    this.submitPayment = this.submitPayment.bind(this)
    this.submitPaymentwithNewCard = this.submitPaymentwithNewCard.bind(this)
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  componentDidMount(props){
    window.addEventListener("resize", this.updateDimensions);
    var tip = this.state.tipCalulation
    this.Appt.appointment(this.state.appt_id)
    .then(res =>{
      if(res){
        const appointment = res
        if(appointment && appointment.appointments){
            appointment.appointments[0] && appointment.appointments[0].tip_amount ? tip = appointment.appointments[0].tip_amount : 0
          this.setState({
            appointment: appointment.appointments[0],
            tipCalulation: tip
          }, function() {
            var outerThis = this
            var allVehicleUpgrades = []
            this.state.appointment.appointment_vehicles.forEach(function(appt_vehicle){
              var upgrades = appt_vehicle.package.upgrades
              var map = []
              var currentVehicleUpgrades = []

              upgrades.forEach(function(upgrade){
                map[upgrade.id] = upgrade
              })
              appt_vehicle.upgrade_ids.forEach(function(id){
                currentVehicleUpgrades.push(map[id])
              })
              allVehicleUpgrades.push(currentVehicleUpgrades)
              outerThis.setState({
                allVehicleUpgrades: allVehicleUpgrades
              })
            })
            this.getCreditCards()
          });
        }

      }
      else {
        this.setState({
          open: true,
          errorMessage: "Cannot find the appointment."
        })
        throw new Error('Cannot retrieve appointment: ' + res);
      }
    })
    .catch(err =>{
      this.setState({
        open: true,
        errorMessage: "Cannot find the appointment."
      })
      throw new Error('Error retrieving appointment: ' + err.message);
    })

    this.Appt.getUser()
    .then(res =>{
      if(res){
        this.setState({
          accountBalance: res.account_balance
        })
    }
    else{
      this.setState({
        open: true,
        errorMessage: "Error retrieving account balance, if you think you should have account balance and would like to pay with it, please contact support"
      })
      throw new Error('Cannot retrieve account balance: ' + res);
    }
  })
    .catch(err =>{
      this.setState({
        errorMessage: "Error retrieving account balance, if you think you should have account balance and would like to pay with it, please contact support"
      })
      throw new Error('Error retrieving account balance: ' + err.message);
    })

  }

  showGiftCard() {
    this.setState({
      giftCardChoosen: true,
      creditCardChosen: false
    })
  }
  openLoadingModal() {
    this.setState({
      loadingModalOpen: true
    })
  }
  submitPayment(totalDueAfterAccount) {
    if(!this.state.creditCard && parseFloat(totalDueAfterAccount) > 0){
      this.setState({
        open: true,
        errorMessage: "Please choose a credit card or add a gift card!"
      })
    }
    else{
      this.setState({
        open: false,
        errorMessage: "",
        loadingModalOpen: true
      })
      var ccValue = null
      if (this.state.creditCard){
        ccValue = this.state.creditCard.value
      }
      this.Appt.charge(this.state.tipCalulation * 100, this.state.appt_id, ccValue, this.state.useAccountBalance)
      .then(res =>{
        if(res && res.errors){
          this.setState({
            open: true,
            errorMessage: "Please chose a credit card or add a gift card!"
          })
        }
        else if(res){
          this.setState({
            open: false,
            errorMessage: ""
          })
          this.setState({
            successfulApptModal: true
          })
        }
        else {
          throw new Error('Cannot charge card: ' + res);
        }
      })
      .catch(err =>{
          throw new Error('Error charging card: ' + err.message);
      })
    }
  }
  submitPaymentwithNewCard(creditCard) {
    if(!creditCard){
      this.setState({
        open: true,
        errorMessage: "Please choose a credit card or add a gift card!"
      })
    }
    else{
      this.setState({
        open: false,
        errorMessage: "",
        loadingModalOpen: true
      })
      var ccValue = null
      this.Appt.charge(this.state.tipCalulation * 100, this.state.appt_id, creditCard, this.state.useAccountBalance)
      .then(res =>{
        if(res && res.errors){
          this.setState({
            open: true,
            errorMessage: "Please chose a credit card or add a gift card!"
          })
        }
        else if(res){
          this.setState({
            open: false,
            errorMessage: ""
          })
          this.setState({
            successfulApptModal: true
          })
        }
        else {
          throw new Error('Cannot charge card: ' + res);
        }
      })
      .catch(err =>{
          throw new Error('Error charging card: ' + err.message);
      })
    }
  }
  promoPopup() {
    this.setState ({
      modalIsOpen: true
    })
  }
  tipPopup() {
    this.setState ({
      tipModalIsOpen: true
    })
  }
  calculateTip(percent) {
    var tip = parseFloat((this.state.appointment.base_amount)/100) * (percent)
    this.setState({
      tipCalulation: tip.toFixed(2)
    })
  }
  calculateCustomTip(tip) {
    this.setState({
      tipModalIsOpen: false
    })
  }
  check_promo(){
    this.setState({
      error: ""
    })
    this.Appt.check_promo(this.state.appt_id, this.state.promoString)
    .then(res =>{
      if(res.errors){
        this.setState({
          promoResult: res.errors
        })
      }
      else if(res) {
        this.setState({
          promoResult: "The Promo Code is being applied...",
          appointment: res.appointment,
          modalIsOpen: false
        })

      }
      else {
        throw new Error('Invalid response to check promo: ' + res);
      }
    })
    .catch(err =>{
        this.setState({
          open: true,
          errorMessage: "The promo code could not be processed"
        })
        throw new Error('Error checking response to promo: ' + err.message);
    })
  }
  showCreditCards(){
    this.setState({
      creditCardChosen: true,
      giftCardChoosen: false,
      creditCardOptions: this.state.creditCardOptions,
      hideTipButtons: true

    })
  }
  getCreditCards() {
    this.Appt.creditCards()
    .then(res =>{
      if(res.errors){
        this.setState({
          open: true,
          errorMessage: "Could not retrieve Credit Cards"
        })
      }
      else if(res){
        this.setState({
          error: ""
        })
        var creditCardOptions = []
        var counter = 0
        creditCardOptions[counter] = {}
        creditCardOptions[counter].value = "new"
        creditCardOptions[counter].label = "Add New Card"
        counter++;
        var defaultCard = {}
        res.credit_cards.forEach((cc) => {
          if(cc.default_card == true){
            defaultCard.value = cc.id
            defaultCard.label = cc.brand + " " +cc.last4
          }
          creditCardOptions[counter] = {}
          creditCardOptions[counter].value = cc.id
          creditCardOptions[counter].label = cc.brand + " . " + cc.last4
          counter  = counter + 1
        })
        this.setState({
          creditCard: defaultCard,
          creditCardOptions: creditCardOptions
        })
      }
      else {
        throw new Error('Invalid response when retrieving credit cards: ' + res);
      }

    })
    .catch(err =>{
      this.setState({
        error: "Could not retrieve Credit Cards"
      })
      throw new Error('Error retrieving credit cards' + err.message);
    })
  }
  goToDashboard() {
    window.location.href = '../'
  }
  checkGiftcardBalance() {
    this.Appt.processRedeem(this.state.giftcardCode)
    .then(res =>{
      if(res.errors){
        this.setState({
          errorMessage: res.errors,
          open: true
        })
      }
      this.setState({
        error: ""
      })
    })
    .catch(err =>{
      this.setState({
        error: "Could not process Giftcard"
      })
      throw new Error('Error processing giftcard: ' + err.message);
    })
  }

  handleSubmit = event =>  {
    //removing code from this handleSubmit block. don't believe it was ever used but leaving in the function to not cause a crash if accessed from somewhere I can't find.
  }

  handleChange = event => {
    this.setState({promoString: event.target.value});
  }
  handleCCChange = event => {
    if(event.value =="new"){
      this.setState({
        newCCmodal:true
      })
    }
    this.setState({creditCard: event});
  }
  handleTipChange = event => {
    this.setState({tipCalulation: event.target.value});
  }
  handleGiftCardChange = event => {
    this.setState({giftcardCode: event.target.value});
  }
  removePromo() {
    this.Appt.removePromo(this.state.appt_id)
    .then(res =>{
      if(res.errors){
        this.setState({
          error: "Could not remove promo code at this time"
        })
        throw new Error('Error removing promo code from appoitnment: ' + res.errors);
      }
      else if(res){
        this.setState({
          error: ""
        })
      }
      else {
        throw new Error('Error removing promo code from appoitnment: ' + res);
      }
      this.setState({
        appointment:res.appointment
      })
    })
    .catch(err =>{
      this.setState({
        error: "Could not remove promo code at this time"
      })
      throw new Error('Error removing promo code from appoitnment: ' + err.message);
    })
  }

  changeSlide = slide => {
    var appt_vehicle = this.state.appointment.appointment_vehicles[slide]
    var upgrades = appt_vehicle.package.upgrades
    var map = []
    var currentVehicleUpgrades = []
    upgrades.forEach(function(upgrade){
      map[upgrade.id] = upgrade
    })
    appt_vehicle.upgrade_ids.forEach(function(id){
      currentVehicleUpgrades.push(map[id])
    })
    this.setState({
      currentVehicleUpgrades: currentVehicleUpgrades
    })
  }
  useBalance(useBalance) {
    this.setState({
      useAccountBalance: useBalance
    })
  }
  confirmAppt() {
    this.Appt.confirmAppt(this.state.appointment.id)
    .then(res =>{
      if(res.errors){
        this.setState({
          error: "Could not confirm appointment"
        })
        throw new Error('Error Confirming appointment ' + res.errors);
      }
      else if (res){
        this.setState({
          error: "",
          appointment: res.appointment
        })
      }
      else {
        throw new Error('Error Confirming appointment ' + res);
      }
    })
    .catch(err =>{
      this.setState({
        error: "Could not confirm appointment"
      })
      throw new Error('Error Confirming appointment ' + err.message);
    })
  }
  closeNewCreditCard(card){
     var card2 = {}
     card2.value = card.id
     card2.label = "this is the new card"
    this.Appt.creditCards()
    .then(res =>{
      if(res.errors){
        this.setState({
          error: "Could not get Credit Cards"
        })
        throw new Error('Error getting credit cards ' + res.erros);
      }
      else if(res) {
        this.setState({
          error: ""
        })
        var creditCardOptions = []
        var counter = 1
        var defaultCard = {}
        creditCardOptions[0] = {}
        creditCardOptions[0].value = "new"
        creditCardOptions[0].label = "Add New Card"
        res.credit_cards.forEach((cc) => {
          if(cc.default_card == true){
            defaultCard.value = cc.id
            defaultCard.label = cc.brand + " " +cc.last4
          }
          creditCardOptions[counter] = {}
          creditCardOptions[counter].value = cc.id
          creditCardOptions[counter].label = cc.brand + " " +cc.last4
          counter  = counter + 1
        })
        this.setState({
          newCCmodal: false,
          loadingModalOpen: false,
          creditCard: card2,
          creditCardOptions: creditCardOptions
        })

      }
      else {
        throw new Error('Error getting credit cards ' + res);
      }
    })
    .catch(err =>{
      this.setState({
        error: "Could not get Credit Cards"
      })
      throw new Error('Error Getting credit cards ' + err.message);
    })

  }
  closeNewCCmodal() {
    this.setState({
      newCCmodal: false
    })
  }

  closeWindow = (event) => {
    this.setState({
      modalIsOpen: false
    })
  }
  closeTipWindow = (event) => {
    this.setState({
      tipModalIsOpen: false
    })
  }
  setOpenToFalse = () => {
    this.setState({
      open:false
    })
  }
    render(){
      const customStyles = this.state.width < 780 ?
      {
        content: {
          top: '20%',
          left: '0%',
          right: '0%',
          height: '35%',
          backgroundColor: 'white'
        }
      }:
      {
        content: {
          top: '20%',
          left: '25%',
          right: '25%',
          height: '40%',
          backgroundColor: 'white'
        }
      }
      const newCCStyle =
      this.state.width < 780 ?
      {
        content: {
          width: '98%',
          left:'1%',
          height: '35%',
          padding: '0px !important'
        }
      }:
        {
          content: {
            width: '50%',
            left:'25%',
            height: '35%',
            padding: '0px !important'
          }
        }
      const minimumStyle = {
        content: {
          top                   : '40%',
          left                  : '20%',
          height                : '30%',
          width                 : '60%',
          padding               : '10px',
          right                 : 'auto',
          backgroundColor       : '#253D59',
          color                 : 'white',
        }
      }
    //  totalAmount += this.props.appointmentPackage.amount/100
      var dateString = ""
      var showPreferred = false
      if(this.state.appointment){
        var appointment = this.state.appointment
        var state = this.state.appointment
        var textString = ""
        var color = null
        switch(appointment.aasm_state){
          case "new":{
            textString = "Pending - We will send you a confirmation shortly "
            color = 'black'
            showPreferred = true
          }
          break;
          case "confirmed": {
            textString = "Confirmed - We will see you at the appointment "
            color = '#5BBA76'
          }
          break;
          case "awaiting_confirmation":{
            textString = "Awaiting Confirmation - Please confirm your appointment";
            color = '#E7643E'
            showPreferred = true
          }
          break;
          case "keys_received":{
            textString = "Spiffy is on-site, and your service is currently in process";
            color = '#3775AD'
          }
          break;
          case "in_process":{
            textString = "Spiffy is on-site, and your service is currently in process";
            color="blue"
          }
          break;
          case "awaiting_payment":{
            textString = "Your Appointment is complete, please rate and pay";
            color = '#3775AD'
          }
          case "awaiting_payment_age24":{
            textString = "Your Appointment is complete, please rate and pay";
            color = '#3775AD'
          }
          break;
          case "keys_returned":{
            textString = "Your Appointment is complete, please rate and pay";
            color = '#3775AD'
          }
          break;
          case "needs_attention":
            textString = "You have a pending appointment scheduled for "
          break;
          case "completed":{
            textString = "Completed"
            color ="black"
          }
          break;
          default:
            textString = "default"
            color = '#3775AD'
        }
        var settings = {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:true,
          afterChange: current => this.changeSlide(current)
        };
        var date = moment.parseZone(appointment.start_at)
        var timezone_suffix = appointment.start_at_timezone_abbr ? ` ${appointment.start_at_timezone_abbr}` : '';
        var strTime = date.format('h:mm a') + timezone_suffix;
        dateString = date.format("MMMM D")
        var vehiclesHTML = []
        var i = 0
        var outerThis = this
        appointment.appointment_vehicles.forEach(function(vehicle) {

          vehiclesHTML.push(<ApptVehicleDetails aasm_state = {appointment.aasm_state} appointmentID = {appointment.id} upgrades = {outerThis.state.allVehicleUpgrades[i]} vehicle ={vehicle} /> )
          i++
        });
        var ccValue = null
        if(this.state.creditCard){
          ccValue = this.state.creditCard.value
        }

        var totalToPay = parseFloat(appointment.base_amount/100) + parseFloat(this.state.tipCalulation > 0 ? this.state.tipCalulation:0 )
        if(this.state.useAccountBalance){
          var apptAccountBalance = this.state.accoutBalanceTowardAppt/100
          var accountBalance = parseFloat(this.state.accountBalance/100)
          var totalDueAfterAccount = 0

          if(accountBalance > totalToPay){
            apptAccountBalance = totalToPay.toFixed(2)
            accountBalance = accountBalance - totalToPay
            totalDueAfterAccount = 0
          }
          else{
            apptAccountBalance = accountBalance
            totalDueAfterAccount = totalToPay - accountBalance
            accountBalance = 0
          }
        }
        else{
          totalDueAfterAccount = totalToPay
          apptAccountBalance = 0
        }
        const styles = {
            'backgroundColor': color
        }
        return (
          <div className="cardWide">
          <div className="card-title2 text-white text-center" style={styles}>
            <h4 className="statusHeader text-white">{textString}</h4>
          </div>
          <div className="card-title2 darkBlue">
            <h4 className="apptDetailsHeader">
            <div>{showPreferred ? "Preferred: " : ""}</div>
              <img className="mr-3 detailIcon constant-size" src={Calendar}>
              </img>{dateString}<img className="mr-3 detailIcon constant-size" src={Clock}></img>{strTime}
              <img className="mr-3 detailIcon constant-size" src={MapPointer}></img>{appointment.address.display_title}
            </h4>
          </div>

          {(appointment.appointment_vehicles && appointment.appointment_vehicles.length > 1) &&
             <Slider{...settings}>
                {vehiclesHTML}
            </Slider>
          }
          {(appointment.appointment_vehicles && appointment.appointment_vehicles.length <= 1) &&
             <div>
                {vehiclesHTML}
            </div>
          }
          {(this.state.errorMessage && this.state.errorMessage.length) &&
            <ErrorSnackBar setOpenToFalse = {this.setOpenToFalse} color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
          }
          <div className="totalDetails">
          {appointment.adjustment_v2_amount_in_dollars > 0 &&
          <div className="twoColumn">
            <h6>Adjustment({appointment.adjustment_v2_reason})</h6>
            <h6>${appointment.adjustment_v2_amount_in_dollars.toFixed(2)}</h6>
          </div>
          }
          {(appointment.promo_code && appointment.promo_code.promo_savings_in_dollars) &&
            <div className="twoColumn">
              <h6> Promo Code({appointment.promo_code.title})<Trash onClick={() => this.removePromo()}/></h6>
              <h6> - $ {appointment.promo_code.promo_savings_in_dollars}</h6>
            </div>
            }
            <div className="twoColumn">
              <h6>{"Sales Tax (" + appointment.address.postal + " : " + appointment.address.tax_rate + "%)" } </h6>
              <h6>${appointment.tax_amount_in_dollars.toFixed(2)}</h6>
            </div>
            {appointment.travel_fee > 0 &&
            <div className="twoColumn">
              <h6>Travel Fee </h6>
              <h6>${(appointment.travel_fee/100.0).toFixed(2)}</h6>
            </div>
            }
            <div className="twoColumn">
              <h6><b>Subtotal</b></h6>
              <h6><b>${appointment.base_amount/100.0}</b></h6>
            </div>
            <div className="twoColumn">
              <h6>Tip Amount</h6>
              <h6>${this.state.tipCalulation}</h6>
            </div>
            { (this.state.useAccountBalance && this.state.accountBalance > 0)  && <div className="twoColumn">
                  <h6>Account Balance</h6>
                  <h6>-${apptAccountBalance}</h6>
                </div>
            }
            { ((appointment.aasm_state == 'awaiting_payment_age24' || appointment.aasm_state == 'awaiting_payment' || appointment.aasm_state == 'keys_returned' || appointment.aasm_state == 'awaiting_payment_auto_failed')  && !this.state.hideTipButtons) && <div className="twoColumn">
              <button className="btn btn-primary tipbutton" onClick={() => this.calculateTip(0.15)}>15%</button>
              <button className="btn btn-primary tipbutton" onClick={() => this.calculateTip(0.18)}>18%</button>
              <button className="btn btn-primary tipbutton" onClick={() => this.calculateTip(0.20)}>20%</button>
              <button className="btn btn-primary tipbutton tip-custom" onClick={() => this.tipPopup()}>Custom</button>
            </div>
            }
            <div className="twoColumn">
              <h4><b>Total</b></h4>
              <h4>${totalDueAfterAccount.toFixed(2)}</h4>
            </div>
            {(!appointment.promo_code && appointment.aasm_state != "completed") &&
              <div className="twoColumn">
                <button className="btn btn-primary addPromobutton" onClick={() => this.promoPopup()}>Add Promo Code</button>
              </div>
            }
            <Modal
              isOpen={this.state.tipModalIsOpen}
              contentLabel="Example Modal"
              style={customStyles}
            >
            <div className="promoCodeModal">
              <CloseIcon className='closeButton' onClick={(e) => this.closeTipWindow(e)} />
              <h6>Enter a Custom Tip Amount</h6>
              <input onChange={this.handleTipChange} className="promoInput"></input>
              <button className="btn btn-primary addPromobutton" onClick={() => this.calculateCustomTip(this.state.tipCalulation)}>Submit</button>
            </div>
            </Modal>
            <hr></hr>
            {((appointment.aasm_state == 'awaiting_payment_age24' || appointment.aasm_state == 'awaiting_payment' || appointment.aasm_state == 'keys_returned' || appointment.aasm_state == 'awaiting_payment_auto_failed') && this.state.accountBalance > 0) && <div className="center">
                <p className="label">Use Account Balance? ({(this.state.accountBalance/100).toFixed(2)})</p>
                <BooleanSwitch
                checkUseBalance = {this.useBalance}
                />
              </div>
            }
            {((appointment.aasm_state == 'awaiting_payment_age24' || appointment.aasm_state == 'awaiting_payment' || appointment.aasm_state == 'keys_returned' || appointment.aasm_state == 'awaiting_payment_auto_failed')&& totalDueAfterAccount > 0) && <div className="twoColumn">
              <button className= "btn btn-primary paymentMethodButton" onClick={() =>this.showCreditCards()}>Credit Card</button>
              <button className= "btn btn-primary paymentMethodButton" onClick={() =>this.showGiftCard()}>Giftcard</button>
            </div>
            }
          {this.state.creditCardChosen &&
              <Select
                  name="form-field-name"
                  value={ccValue}
                  onChange={this.handleCCChange}
                  options={this.state.creditCardOptions}
                />
          }
          {(this.state.giftCardChoosen && totalDueAfterAccount > 0) &&
            <div>
              <br></br>
              <h6>Please enter the gift card code</h6>
              <div className="twoColumn">
                <input value={this.state.giftcardCode} onChange={this.handleGiftCardChange}></input>
                <button onClick={() => this.checkGiftcardBalance()}>Check Balance</button>
              </div>
            </div>
          }
          {(this.state.giftCardChoosen || this.state.creditCardChosen) &&
            <div>
              <button  className= "btn btn-primary submitButton" onClick={() => this.submitPayment(totalDueAfterAccount)}>Submit Payment</button>
            </div>
          }
          {appointment.aasm_state == 'awaiting_confirmation'  &&
            <div>
              <button  className= "btn btn-primary submitButton" onClick={() => this.confirmAppt()}>Confirm</button>
            </div>
          }
          <p>{this.state.appointmentError}</p>
          </div>
          <Modal
            isOpen={this.state.modalIsOpen}
            contentLabel="Example Modal"
            style={customStyles}
            >
            <div className="promoCodeModal">
              <CloseIcon className='closeButton' onClick={(e) => this.closeWindow(e)} />
              <h3>Add Promo Code</h3>
              <h6>If you have a valid promo code, we will apply it to your appointment </h6>
              <input value={this.state.promoString} onChange={this.handleChange} className="promoInput"></input>
              <button className="btn btn-primary addPromobutton" onClick={() => this.check_promo()}>Submit</button>
              <h6>{this.state.promoResult}</h6>
            </div>
          </Modal>
          <Modal
            isOpen={this.state.loadingModalOpen}
            contentLabel="Example Modal"
            style={minimumStyle}
            >
            <ClipLoader
              className={override}
              sizeUnit={"px"}
              size={100}
              color={'#ffffff'}
              loading={this.state.loadingModalOpen}
            />
          </Modal>
          <Modal
            isOpen={this.state.successfulApptModal}
            contentLabel="Example Modal"
            style={minimumStyle}
            >
            <div className="centerText2">
              <h3>Your appointment is complete!</h3>
              <button className="btn btn-primary btn-block text-white text-center" onClick={() => this.goToDashboard()}>Okay</button>
            </div>
          </Modal>
          <Modal
            isOpen={this.state.newCCmodal}
            contentLabel="Example Modal"
            style={newCCStyle}
            >
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Add New Card</h4>
            </div>
            <NewCCForm closeModal={this.closeNewCCmodal} afterSave={this.submitPaymentwithNewCard}/>
          </Modal>
        </div>

              )
            }
            else {
              return null
            }
    }
}
export default ShowDetails;



// WEBPACK FOOTER //
// ./src/Components/ShowDetails.js